// extracted by mini-css-extract-plugin
module.exports = {"submenu":"Submenu_submenu__1PCnm","submenuRight":"Submenu_submenuRight__2w938"};